import { render } from "./CustomField.vue?vue&type=template&id=15a86f04&scoped=true"
import script from "./CustomField.vue?vue&type=script&lang=js"
export * from "./CustomField.vue?vue&type=script&lang=js"

import "./customField.scss?vue&type=style&index=0&id=15a86f04&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a86f04"]])

export default __exports__